import { Link } from 'react-router-dom';

interface MidCTABannerProps {
  text?: string;
}

export default function MidCTABanner({
  text = 'Ready to protect your Utah home with a quality roof?',
}: MidCTABannerProps) {
  return (
    <section className="py-8 bg-charcoal border-t border-charcoal-light border-b border-charcoal-light">
      <div className="max-w-7xl mx-auto px-6">
        <div className="flex flex-col md:flex-row items-center justify-between gap-5">
          <div className="flex items-center gap-4">
            <div className="w-10 h-10 flex items-center justify-center bg-brand-orange rounded-lg flex-shrink-0">
              <i className="ri-home-3-fill text-white text-xl"></i>
            </div>
            <div>
              <p className="font-heading font-800 text-white text-xl md:text-2xl uppercase tracking-wide leading-tight">
                {text}
              </p>
              <p className="font-body text-white/50 text-xs mt-0.5">
                Free inspections &middot; No obligation estimates &middot; Serving all of Utah
              </p>
            </div>
          </div>
          <div className="flex items-center gap-3 flex-shrink-0">
            <a
              href="tel:+18015550199"
              className="flex items-center gap-2 border border-white/25 hover:border-white/60 text-white px-5 py-2.5 rounded-md font-body text-sm font-600 transition-colors cursor-pointer whitespace-nowrap"
            >
              <i className="ri-phone-fill text-brand-orange"></i>
              (801) 555-0199
            </a>
            <Link
              to="/#estimate"
              className="bg-brand-orange hover:bg-brand-orange-dark text-white px-6 py-2.5 rounded-md font-heading font-700 text-sm uppercase tracking-wider transition-colors cursor-pointer whitespace-nowrap"
            >
              Get Free Estimate
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}
